module.exports = __webpack_public_path__ + "static/media/Western.18818d7c.png";